"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _escapeRegExp = _interopRequireDefault(require("lodash/escapeRegExp"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
const matchString = function (match, str) {
  let ignoreNull = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
  const regex = new RegExp(`${match.split(/(\s+)/).filter(h => h.trim()).map(hl => '(' + (0, _escapeRegExp.default)(hl) + ')').join('|')}`, 'gi');
  if (ignoreNull && !match) {
    const nullRegex = /a^/gi; // Should match nothing

    return [[str], nullRegex];
  }
  return [str.split(regex), regex];
};
var _default = exports.default = matchString;